import * as React from "react";
import styled from "styled-components";

import { Text } from "src/library/components/Text";
import { ProcessJobStatus } from "src/core/process-job/api/processJobs.api";

interface IProps {
  status?: ProcessJobStatus;
}

const StatusWrapper = styled("span")<IProps>`
  position: relative;
  .status-code {
    text-transform: capitalize;
    color: ${({ status, theme }) => {
    switch (status) {
      case "error":
        return theme.colors.error;
      case "success":
        return theme.colors.success;
      case "part_error":
        return theme.colors.warn;
      case "in_progress":
        return theme.colors.primaryDark;
      case "queued":
      default:
        return theme.colors.draftOrder;
    }
  }};
  }

  .help-icon {
    cursor: help;
    display: inline;
    margin-left: 5px;
  }
`;

/**
 * Gets the order status
 */
export const ProcessJobStatusDisplay = ({ status }: IProps) => {
  if (status) {
    return (
      <StatusWrapper status={status}>
        <Text
          weight="bold"
          className="status-code"
        >
          {status.replace(/_/g, " ")}
        </Text>
      </StatusWrapper>
    );
  }

  return (
    <StatusWrapper>
      -
    </StatusWrapper>
  );
};
